import { DataTableArgs } from 'src/components/DataTable/DataTable.types';
import { getUserFullname } from 'src/utils/getFullname';
import { baseApi } from 'src/api/baseApi';
import { QueryPayload } from 'src/api';
import { Buffer } from 'buffer';
import {
    CreateEmployeePayload,
    GetDataForCreateUserResponse,
    GetTeachersResponse,
    GetUsersResponse,
    UpdateEmployeePayload,
} from 'src/api/endpoints/users/users.types';

const api = baseApi.injectEndpoints({
    endpoints: builder => ({
        getUserProfileImage: builder.query<
            { buffer: ArrayBuffer; base: string } | null,
            { params: { userId: number } }
        >({
            providesTags: (_r, _e, { params }) => [
                { type: 'Avatar', id: params.userId },
            ],
            query: ({ params }): QueryPayload => ({
                url: `/users/${params.userId}/avatar`,
                method: 'GET',
                responseType: 'arraybuffer',
            }),
            transformResponse: (response: ArrayBuffer) => {
                if (!response || !response.byteLength) return null;

                return {
                    buffer: response,
                    base: Buffer.from(response).toString('base64'),
                };
            },
        }),
        getUsers: builder.query<GetUsersResponse, DataTableArgs>({
            providesTags: ['User'],
            query: arg => ({
                url: '/users/page',
                data: arg,
                method: 'post',
                errorMessage: 'Не удалось получить информацию о пользователях!',
            }),
            transformResponse(val: any) {
                return {
                    data: {
                        content: val.items.map(el => ({
                            ...el,
                            filial: el.filial.name,
                            filialId: el.filial.id,
                            role: el.role.id,
                            roleName: el.role.name,
                        })),
                    },
                    metaData: {
                        totalOffset: val.meta.offset,
                        totalRecordsElement: val.meta.total,
                    },
                };
            },
        }),
        addUserAccount: builder.mutation<void, CreateEmployeePayload>({
            invalidatesTags: ['User'],
            query: arg => ({
                url: 'users',
                method: 'post',
                data: {
                    ...arg,
                    roleCode: arg.role,
                    filialId: arg.filial,
                },
                errorMessage: 'Не удалось добавить пользователя!',
            }),
        }),
        updateUserAccount: builder.mutation<void, UpdateEmployeePayload>({
            invalidatesTags: ['User'],
            query: arg => ({
                url: `users/${arg.id}`,
                method: 'PATCH',
                data: arg,
                errorMessage: 'Не удалось обновить студента!',
            }),
        }),
        getTeachers: builder.query<GetTeachersResponse, null>({
            providesTags: ['User'],
            query: _ => ({
                url: '/users/teachers',
                method: 'get',
                errorMessage:
                    'Не удалось получить информацию о преподавателях!',
            }),
            transformResponse(val: any) {
                return val.map(el => ({
                    ...el,
                    fio: getUserFullname(el),
                }));
            },
        }),
        getDataForCreateUser: builder.query<
            GetDataForCreateUserResponse,
            void | null
        >({
            query: _ => ({
                url: '/users/data/create',
                method: 'get',
                errorMessage:
                    'Не удалось получить информацию для создания пользователя!',
            }),
        }),
    }),
});

export const {
    useGetUserProfileImageQuery,
    useAddUserAccountMutation,
    useUpdateUserAccountMutation,
    useGetDataForCreateUserQuery,
} = api;
